import filterUrlHelper from '../helpers/filter-url'

const RoutingService = {
  addHistoryItem(options, replaceState=false) {
    const url = `${window.location.pathname}${filterUrlHelper.currentStateUrlParamsString(options)}`

    // Including `turbolinks: {}` in the state object causes turbolinks to handle this history item
    // when the Back button is used. This ensures that everything gets properly loaded when moving
    // between pages using the Back button.
    const historyState = {turbolinks: {}}

    if (replaceState) {
      history.replaceState(historyState, null, url)
    } else {
      history.pushState(historyState, null, url)
    }
  }
}

export default RoutingService
